import { EditableVariableList } from "../../../../components/editable-variable-list";
import type { TestVariable } from "../../../../types";

interface VariablesTabProps {
  variables: TestVariable[];
  onVariablesChange: (variables: TestVariable[]) => void;
  isLoading: boolean;
}

export function VariablesTab({ variables, onVariablesChange, isLoading }: VariablesTabProps) {
  return (
    <EditableVariableList
      variables={variables}
      onVariablesChange={onVariablesChange}
      isLoading={isLoading}
    />
  );
}
